import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=4764ab52&scoped=true"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"
import style0 from "./Overlay.vue?vue&type=style&index=0&id=4764ab52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764ab52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/bamboo-agent-home/xml-data/build-dir/MEM-MEMUI-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4764ab52')) {
      api.createRecord('4764ab52', component.options)
    } else {
      api.reload('4764ab52', component.options)
    }
    module.hot.accept("./Overlay.vue?vue&type=template&id=4764ab52&scoped=true", function () {
      api.rerender('4764ab52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/overlay/Overlay.vue"
export default component.exports